import {
  PRODUCT_TYPE_KENTICO_ATTRIBUTE_NAME,
  PRODUCT_TYPE_KENTICO_ATTRIBUTE_VALUES,
} from '../constants/product-api.const';
import { Product } from '../models';

export function isPaintProduct(product: Product): boolean {
  return !!product.Attributes?.find((attr) => attr.Name === PRODUCT_TYPE_KENTICO_ATTRIBUTE_NAME)?.Values.find(
    (value) => value === PRODUCT_TYPE_KENTICO_ATTRIBUTE_VALUES.Paint,
  );
}
